/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VirtualList from 'react-tiny-virtual-list';
import { withRouter } from 'react-router-dom';
import {
  SEARCH_RESULTS_OVER_SCAN_BUFFER,
  SEARCH_RESULTS_ELEMENTS_HEIGHT_ABOVE_LIST,
  SEARCH_RESULTS_HEIGHT_OFFSET,
  SEARCH_RESULTS_ITEM_SIZE,
  FILE
} from '../../../constants';

const SearchResults = ({
  currentValue,
  entities,
  loading,
  results,
  total,
  setQueryParams,
  closeModal,
  history
}) => {
  const [verifiedRanges, setVerifiedRanges] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentResults, setCurrentResults] = useState('');
  const [allResults, setAllResults] = useState([]);
  const [currentParams, setCurrentParams] = useState('');

  useEffect(() => {
    if (!loading) {
      const newResults = results.map(({ id }) => id).join(',');
      if (currentResults !== newResults) {
        const newParams = `${currentValue},${entities.join(',')}`;
        if (newParams !== currentParams) {
          setAllResults(results);
          setCurrentParams(newParams);
          if (verifiedRanges.length) setVerifiedRanges([]);
        } else {
          setAllResults(allResults.concat(results));
        }
        setCurrentResults(newResults);
      }
    }
  }, [
    allResults,
    currentParams,
    currentResults,
    currentValue,
    entities,
    loading,
    results,
    total,
    verifiedRanges.length
  ]);

  const handleRenderedItems = async ({ startIndex }) => {
    const rowsLength = allResults.length;
    const loadIndex = Math.floor(rowsLength / 2) - SEARCH_RESULTS_OVER_SCAN_BUFFER;
    if (loadIndex > 0 && loadIndex < startIndex && !verifiedRanges.includes(loadIndex)) {
      setQueryParams({ value: currentValue, offset: allResults.length });
      setVerifiedRanges([...verifiedRanges, loadIndex]);
      setCurrentIndex(startIndex + SEARCH_RESULTS_OVER_SCAN_BUFFER);
    }
  };

  const getNavigationRoute = ({ id, docType }) =>
    docType === FILE ? `/media/edit/${id}` : `/data-listing/${docType}/update/${id}`;

  const navigate = ({ id, docType }) => {
    history.push(getNavigationRoute({ id, docType }));
    closeModal();
  };

  const getDateFormat = date => {
    const newDate = new Date(date);
    const day = `0${newDate.getDate()}`.slice(-2);
    const month = `0${newDate.getMonth() + 1}`.slice(-2);
    const year = String(newDate.getYear()).slice(-2);
    return `${day}.${month}.${year}`;
  };

  if (!allResults.length)
    return (
      <div className="list list--search">
        <div className="header header--list">
          <h2>No Results</h2>
        </div>
      </div>
    );

  return (
    <div className="modal__content modal__content--search">
      <div className="header header--list">
        <h2 className="header--list--results">
          About <b>{total}</b> search keywords results
        </h2>
      </div>
      <VirtualList
        width="100%"
        height={
          window.innerHeight -
          SEARCH_RESULTS_ELEMENTS_HEIGHT_ABOVE_LIST -
          SEARCH_RESULTS_HEIGHT_OFFSET
        }
        itemCount={allResults.length}
        itemSize={SEARCH_RESULTS_ITEM_SIZE}
        overscanCount={SEARCH_RESULTS_OVER_SCAN_BUFFER}
        scrollToIndex={currentIndex}
        onItemsRendered={handleRenderedItems}
        renderItem={({ index, style }) => {
          const { id, docType, updated, name, entityIdentifier, published, created, status } =
            allResults[index];
          const updatedDate = updated ? getDateFormat(updated) : null;
          const createdDate = created ? getDateFormat(created) : null;
          const publishedDate = published ? getDateFormat(published) : null;
          return (
            <div key={index} style={style} className="list__item--resultWrapper">
              <div className="list__item list__item--result">
                <div className="list__item-row list__item-row--result">
                  <span className="list__item-identifier">{entityIdentifier}</span>
                  <a
                    href={getNavigationRoute({
                      id,
                      docType
                    })}
                    onClick={() =>
                      navigate({
                        id,
                        docType
                      })
                    }
                    className="list__item-link">
                    {name}
                  </a>

                  <div className="list__item-dates">
                    {publishedDate && (
                      <span>
                        <b>Published: </b>
                        {publishedDate}
                      </span>
                    )}
                    <span>
                      <b>Created: </b>
                      {createdDate}
                    </span>
                    <span>
                      <b>Updated: </b>
                      {updatedDate}
                    </span>
                  </div>
                  <div className="list__item-status">
                    {status && (
                      <span>
                        <b>Status: </b>
                        {status}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      />
      {loading && <span>Loading...</span>}
    </div>
  );
};

SearchResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  results: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  setQueryParams: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  currentValue: PropTypes.string.isRequired,
  entities: PropTypes.array.isRequired
};

export default withRouter(SearchResults);
